import React, { Component } from "react"
import MetaTags from 'react-meta-tags';
import PropTypes from 'prop-types'
import { Link } from "react-router-dom"
import { connect } from "react-redux"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { withTranslation } from "react-i18next"
import settingLink from "./setting-link";
import "flatpickr/dist/themes/material_blue.css"
import Flatpickr from "react-flatpickr"
import { isEmpty, map, size } from "lodash";
import Moment from 'react-moment';
import DeleteModal from "../../components/Common/DeleteModal";
import SettingSidebar from "../../components/VerticalLayout/SettingSidebar";
import { addAppointmentType, getAppointmentType, updateAppointmentType, deleteAppointmentType } from "../../store/settings/Appointment/actions"
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  FormGroup,
  Label,
  Input,
  Button,
  Offcanvas,
  OffcanvasHeader,
  OffcanvasBody,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
} from "reactstrap"
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import ActionEdit from "components/buttons/actionEdit";
import ActionDelete from "components/buttons/actionDelete";
import SafeField from "helpers/SafeField";

class AppointmentType extends Component {
  constructor(props) {
    super(props)
    this.state = {
      type: ''
    }
    this.handleAppointmentTypeSubmit = this.handleAppointmentTypeSubmit.bind(this)
    this.toggleRightCanvas = this.toggleRightCanvas.bind(this);
    this.toggleBackdrop = this.toggleBackdrop.bind(this);
    this.onClickDelete = this.onClickDelete.bind(this);
  }
  toggleBackdrop() {
    this.setState({ isBackdrop: !this.state.isBackdrop });
  }
  toggleDeleteModal = () => {
    this.setState(prevState => ({
      deleteModal: !prevState.deleteModal,
    }));
  };
  onClickDelete = (type) => {
    this.setState({ type: type });
    this.setState({ deleteModal: true });
  };

  handleDeleteType = () => {
    const { onDeleteType } = this.props;
    const { type } = this.state;
    if (type.id !== undefined) {
        onDeleteType(type);
      this.setState({ deleteModal: false });
    }
  };
  toggle() {
    this.setState(prevState => ({
      isRight: !prevState.isRight
    }));
  }
  handleAppointmentTypeSubmit(value) {
    this.props.addAppointmentType(value, this.props.history);
  }

  componentDidMount() {
    const { onGetAppointmentType } = this.props;
    onGetAppointmentType(localStorage.getItem('userId'));
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    const { types } = this.props;
    if (!isEmpty(types) && size(prevProps.types) !== size(types)) {
      this.setState({ types: {}, isEdit: false });
    }
  }
  toggleRightCanvas() {
    this.setState({ type: "", isEdit: false, isRight: !this.state.isRight });
    this.toggle();
  }
  toggleRightCanvas = arg => {
    const type = arg;
    this.setState({
        type: {
        id: type.id,
        appointmentTypeId: type.appointmentTypeId,
        appointmentTypeTitle: type.appointmentTypeTitle,
        agentId: type.agentId
      },
      isEdit: true,
    });
    this.toggle();
  };
  render() {
    const { types, onUpdateAppType } = this.props;
    const { isEdit, deleteModal } = this.state;
    const type = this.state.type;
    return (
      <React.Fragment>
        {this.props.loading && this.props.loading ? (
          <div className="loading">Loading&#8230;</div>
        ) : null}
        <ToastContainer autoClose={2000} />
        <DeleteModal
          show={deleteModal}
          onDeleteClick={this.handleDeleteType}
          onCloseClick={() => this.setState({ deleteModal: false })}
        />
        <div className="page-content">
          <MetaTags>
            <title>Agent Profile | Realty Space</title>
          </MetaTags>
          <Container fluid>


            <Row className="mb20">
              <Col xl="6">
                <Breadcrumbs
                  title={this.props.t("Agent")}

                  breadcrumbItem={this.props.t("Appointment Type")}
                />

              </Col>

            </Row>
            <Row>
              <Col xl="3">
                <SettingSidebar />
              </Col>

              <Col xl="9">
                <Formik
                  enableReinitialize={true}
                  initialValues={{
                    appointmentTypeTitle: (this.state && this.state.appointmentTypeTitle) || "",

                  }}
                  validationSchema={Yup.object().shape({
                    appointmentTypeTitle: Yup.string().required("This is required"),


                  })}

                  onSubmit={this.handleAppointmentTypeSubmit}
                >
                  {({ errors, touched, values, handleChange, setFieldValue }) => (
                    <Form
                      className="needs-validation"
                    >



                      <Card>
                        <CardBody>
                          <Row>


                            <Col sm="3">
                              <FormGroup className="mb-3">
                                <Label htmlFor="appointmentTypeTitle">
                                  {this.props.t("Title")}
                                </Label>
                                <SafeField
                                  name="appointmentTypeTitle"
                                  onChange={handleChange}

                                  type="text"

                                  className={
                                    "form-control" +
                                    (errors.appointmentTypeTitle && touched.appointmentTypeTitle
                                      ? " is-invalid"
                                      : "")
                                  }

                                  id="appointmentTypeTitle"
                                />
                                <ErrorMessage
                                  name="appointmentTypeTitle"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </FormGroup>

                            </Col>

                            <Col sm="2">
                              <button type="submit" className="btn btn-primary w-md float-left" style={{ marginTop: 31 }}>Add</button>
                            </Col>

                          </Row>


                        </CardBody>
                      </Card>
                      <Card>
                        <CardBody>
                          <h5 className="card-title">Appointment Type History</h5>
                          <div className="table-responsive">
                            <table className="table table-bordered border-primary align-middle table-nowrap mb-0">
                              <thead className="">
                                <tr>
                                  <th>#</th>
                                  <th>Title</th>


                                  <th>Action</th>


                                </tr>
                              </thead>
                              <tbody>
                                {map(types, (type, typekey) => (
                                  <tr key={"_list_" + typekey}>
                                    <th>{typekey + 1}</th>
                                    <td>{type.appointmentTypeTitle}</td>
                                    <td>
                                    <ActionEdit onClick={() => this.toggleRightCanvas(type)} />
                                    <ActionDelete onClick={() => this.onClickDelete(type)} />
                                     

                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        </CardBody>
                      </Card>








                    </Form>
                  )}
                </Formik>




              </Col>

            </Row>
            <Offcanvas
              isOpen={this.state.isRight}
              direction="end"
              toggle={this.toggleRightCanvas}
            >
              <OffcanvasHeader toggle={this.toggleRightCanvas}>
                Update
              </OffcanvasHeader>
              <OffcanvasBody>
                <Formik
                  enableReinitialize={true}
                  initialValues={{
                    id: type.id,
                    appointmentTypeId: type.appointmentTypeId,
                    appointmentTypeTitle: type.appointmentTypeTitle,
                    agentId: type.agentId

                  }}
                  validationSchema={Yup.object().shape({
                    appointmentTypeTitle: Yup.string().required("This is required"),


                  })}

                  onSubmit={values => {

                    if (isEdit) {
                      const updateData = {
                        id: values.id,
                        appointmentTypeId: values.appointmentTypeId,
                        appointmentTypeTitle: values.appointmentTypeTitle,
                        agentId: values.agentId
                      };
                      onUpdateAppType(updateData);
                    } else {

                    }
                    this.toggle();
                  }}
                >
                  {({ errors, touched, values, handleChange, setFieldValue }) => (
                    <Form
                      className="needs-validation"
                    >




                      <Row>


                        <Col sm="12">
                          <FormGroup className="mb-3">
                            <Label htmlFor="appointmentTypeTitle">
                              {this.props.t("Title")}
                            </Label>
                            <SafeField
                              name="appointmentTypeTitle"
                              onChange={handleChange}

                              type="text"

                              className={
                                "form-control" +
                                (errors.appointmentTypeTitle && touched.appointmentTypeTitle
                                  ? " is-invalid"
                                  : "")
                              }

                              id="appointmentTypeTitle"
                            />
                            <ErrorMessage
                              name="appointmentTypeTitle"
                              component="div"
                              className="invalid-feedback"
                            />
                          </FormGroup>

                        </Col>

                        <Col sm="12">
                          <button type="submit" className="btn btn-primary w-md float-left">Update</button>
                        </Col>

                      </Row>



                    </Form>
                  )}
                </Formik>
              </OffcanvasBody>
            </Offcanvas>
          </Container>
        </div>
      </React.Fragment>
    )
  }
}
AppointmentType.propTypes = {
  t: PropTypes.any,
  history: PropTypes.object,
  match: PropTypes.object,
  loading: PropTypes.object,
  addAppointmentType: PropTypes.func,
  onGetAppointmentType: PropTypes.func,
  types: PropTypes.array,
  onDeleteType: PropTypes.func,
  onUpdateAppType: PropTypes.func


}
const mapStateToProps = ({ AppoinmentObject }) => (
  {

    types: AppoinmentObject.types,
    loading: AppoinmentObject.loading

  })
const mapDispatchToProps = dispatch => ({

  addAppointmentType: (data) => dispatch(addAppointmentType(data)),
  onGetAppointmentType: (agentId) => dispatch(getAppointmentType(agentId)),
  onDeleteType: (id) => dispatch(deleteAppointmentType(id)),
  onUpdateAppType: (data) => dispatch(updateAppointmentType(data)),

});
export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(AppointmentType))
